import type { BaseController } from '@infra/controllers/base.controller';
import type { WarmMergeTransferUsecase } from './warm-merge-transfer.usecase';

export class WarmMergeTransferController implements BaseController<void, void> {
  constructor(private usecase: WarmMergeTransferUsecase) {}

  async handle(): Promise<void> {
    await this.usecase.run();
  }
}
